import * as React from 'react';
import { getValue, updateValues } from '../utils/miscUtil';
import { getClosingViewDate, isSameYear, isSameMonth, isSameDecade } from '../utils/dateUtil';
function getStartEndDistance(startDate, endDate, picker, generateConfig) {
    const startNext = getClosingViewDate(startDate, picker, generateConfig, 1);
    function getDistance(compareFunc) {
        if (compareFunc(startDate, endDate)) {
            return 'same';
        }
        if (compareFunc(startNext, endDate)) {
            return 'closing';
        }
        return 'far';
    }
    switch (picker) {
        case 'year':
            return getDistance((start, end) => isSameDecade(generateConfig, start, end));
        case 'quarter':
        case 'month':
            return getDistance((start, end) => isSameYear(generateConfig, start, end));
        default:
            return getDistance((start, end) => isSameMonth(generateConfig, start, end));
    }
}
function getRangeViewDate(values, index, picker, generateConfig) {
    const startDate = getValue(values, 0);
    const endDate = getValue(values, 1);
    if (index === 0) {
        return startDate;
    }
    if (startDate && endDate) {
        const distance = getStartEndDistance(startDate, endDate, picker, generateConfig);
        switch (distance) {
            case 'same':
                return startDate;
            case 'closing':
                return startDate;
            default:
                return getClosingViewDate(endDate, picker, generateConfig, -1);
        }
    }
    return startDate;
}
export default function useRangeViewDates({ values, picker, defaultDates, generateConfig, }) {
    const [defaultViewDates, setDefaultViewDates] = React.useState(() => [getValue(defaultDates, 0), getValue(defaultDates, 1)]);
    const [viewDates, setInternalViewDates] = React.useState(null);
    const startDate = getValue(values, 0);
    const endDate = getValue(values, 1);
    function getViewDate(index) {
        // If set default view date, use it
        if (defaultViewDates[index]) {
            return defaultViewDates[index];
        }
        return (getValue(viewDates, index) ||
            getRangeViewDate(values, index, picker, generateConfig) ||
            startDate ||
            endDate ||
            generateConfig.getNow());
    }
    function setViewDate(viewDate, index) {
        if (viewDate) {
            let newViewDates = updateValues(viewDates, viewDate, index);
            // Set view date will clean up default one
            setDefaultViewDates(
            // Should always be an array
            updateValues(defaultViewDates, null, index) || [null, null]);
            // Reset another one when not have value
            const anotherIndex = (index + 1) % 2;
            if (!getValue(values, anotherIndex)) {
                newViewDates = updateValues(newViewDates, viewDate, anotherIndex);
            }
            setInternalViewDates(newViewDates);
        }
        else if (startDate || endDate) {
            // Reset all when has values when `viewDate` is `null` which means from open trigger
            setInternalViewDates(null);
        }
    }
    return [getViewDate, setViewDate];
}
